import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

export const cesispeRoutes: RouteRecordRaw[] = [
  {
    path: '/cesispe',
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'cesispeTools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'cesispe.transactions' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'transactions',
            name: 'cesispe.transactions',
            component: () =>
              import('@/modules/cesispe/ui/view/transactionsExecuted.vue')
          },
          {
            path: 'release',
            name: 'cesispe.release',
            component: () =>
              import('@/modules/cesispe/ui/view/informationRelease.vue')
          }
          
        ]
      }
    ]
  }
]
